import type { ComparatorOption } from "./types";

export const IS_MANAGER_FIELD_ID = "is_manager";
export const IS_MANAGER_FIELD_NAME = "Has Direct Reports";

export const DEFAULT_COMPARATORS: ComparatorOption[] = [
	{ value: "eq", label: "Equals" },
	{ value: "ne", label: "Does not equal" },
];

export const TEXT_COMPARATORS: ComparatorOption[] = [
	{ value: "eq", label: "Equals" },
	{ value: "regex_contains", label: "Contains" },
	{ value: "ne", label: "Does not equal" },
	{ value: "not_regex_notContains", label: "Does not contain" },
	{ value: "regex_startsWith", label: "Starts with" },
	{ value: "regex_endsWith", label: "Ends with" },
	{ value: "not_regex_notStartsWith", label: "Does not start with" },
	{ value: "not_regex_notEndsWith", label: "Does not end with" },
];

export const NUMERIC_COMPARATORS: ComparatorOption[] = [
	{ value: "eq", label: "Equals" },
	{ value: "ne", label: "Does not equal" },
	{ value: "gt", label: "Greater than" },
	{ value: "gte", label: "Greater than or equal to" },
	{ value: "lt", label: "Less than" },
	{ value: "lte", label: "Less than or equal to" },
];

export const STATIC_DATE_COMPARATORS: ComparatorOption[] = [
	{ value: "lt", label: "Before" },
	{ value: "gt", label: "After" },
	{ value: "eq", label: "On" },
];

export const RELATIVE_DATE_COMPARATORS: ComparatorOption[] = [
	{ value: "eq", label: "Equals" },
	{ value: "lt", label: "Greater than" },
	{ value: "lte", label: "Greater than or equal to" },
	{ value: "gt", label: "Less than" },
	{ value: "gte", label: "Less than or equal to" },
];

export const ANNIVERSARY_COMPARATORS: ComparatorOption[] = [
	{ value: "eq_anniversary", label: "On Anniversary Date" },
	{ value: "before_anniversary", label: "Before Anniversary Date" },
	{ value: "after_anniversary", label: "After Anniversary Date" },
];

export const RELATIVE_DATE_UNITS = [
	{ value: "days", label: "Days Ago" },
	{ value: "months", label: "Months Ago" },
	{ value: "years", label: "Years Ago" },
];

export const ANNIVERSARY_DATE_UNITS = [
	{ value: "days", label: "Days" },
	{ value: "months", label: "Months" },
];
